document.addEventListener('DOMContentLoaded', function() {
  // Set up ZIP code lookup for US addresses
  setupZipCodeLookup();
  
  // Set up tax form option buttons
  setupTaxFormButtons();
  
  // Setup exemption reason fields
  setupExemptionReasonField();
});

// Function to set up ZIP code lookup functionality
function setupZipCodeLookup() {
  const zipField = document.getElementById('AddressZip');
  const cityField = document.getElementById('AddressCity');
  const stateField = document.getElementById('AddressProvince');
  const countryField = document.getElementById('AddressCountry');
  
  if (!zipField) return;
  
  zipField.addEventListener('change', function() {
    // Only perform lookup for US addresses
    if (countryField.value === 'United States') {
      const zipCode = this.value.trim();
      
      // Basic US ZIP code validation
      if (zipCode.length === 5 && /^\d{5}$/.test(zipCode)) {
        fetchLocationFromZipCode(zipCode);
      }
    }
  });
  
  // Fetch location data from ZIP code API
  function fetchLocationFromZipCode(zipCode) {
    fetch(`https://api.zippopotam.us/us/${zipCode}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('ZIP code lookup failed');
        }
        return response.json();
      })
      .then(data => {
        if (data && data.places && data.places.length > 0) {
          // Auto-fill city
          cityField.value = data.places[0]['place name'];
          
          // Auto-select state
          const stateCode = data.places[0]['state abbreviation'];
          for (let i = 0; i < stateField.options.length; i++) {
            if (stateField.options[i].value === stateCode) {
              stateField.selectedIndex = i;
              break;
            }
          }
          
          // Update Texas form visibility if in Texas
          if (stateCode === 'TX') {
            const texasBtn = document.getElementById('texas-option-btn');
            if (texasBtn && !texasBtn.classList.contains('selected')) {
              texasBtn.click();
            }
          } else {
            const generalBtn = document.getElementById('general-option-btn');
            if (generalBtn && !generalBtn.classList.contains('selected')) {
              generalBtn.click();
            }
          }
        }
      })
      .catch(error => {
        console.error('ZIP code lookup error:', error);
      });
  }
}

// Function to set up tax form option buttons
function setupTaxFormButtons() {
  const texasBtn = document.getElementById('texas-option-btn');
  const generalBtn = document.getElementById('general-option-btn');
  const texasForm = document.getElementById('texas-form');
  const generalForm = document.getElementById('general-form');
  const commonFields = document.getElementById('common-form-fields');
  
  if (!texasBtn || !generalBtn) return;
  
  texasBtn.addEventListener('click', function() {
    texasBtn.classList.add('selected');
    generalBtn.classList.remove('selected');
    texasForm.style.display = 'block';
    generalForm.style.display = 'none';
    commonFields.style.display = 'block';
    
    // Update form requirements
    document.querySelectorAll('#texas-form input, #texas-form textarea, #texas-form select').forEach(el => {
      el.setAttribute('required', 'required');
    });
    document.querySelectorAll('#general-form input, #general-form textarea, #general-form select').forEach(el => {
      if (el.id !== 'other-reason') el.removeAttribute('required');
    });
  });
  
  generalBtn.addEventListener('click', function() {
    generalBtn.classList.add('selected');
    texasBtn.classList.remove('selected');
    generalForm.style.display = 'block';
    texasForm.style.display = 'none';
    commonFields.style.display = 'block';
    
    // Update form requirements
    document.querySelectorAll('#general-form input, #general-form textarea, #general-form select').forEach(el => {
      if (el.id !== 'other-reason') el.setAttribute('required', 'required');
    });
    document.querySelectorAll('#texas-form input, #texas-form textarea, #texas-form select').forEach(el => {
      el.removeAttribute('required');
    });
  });
}

// Function to set up exemption reason field
function setupExemptionReasonField() {
  const exemptionReason = document.getElementById('exemption-reason');
  const otherReasonField = document.getElementById('other-reason-field');
  
  if (!exemptionReason || !otherReasonField) return;
  
  exemptionReason.addEventListener('change', function() {
    if (this.value === 'other') {
      otherReasonField.style.display = 'block';
      document.getElementById('other-reason').setAttribute('required', 'required');
    } else {
      otherReasonField.style.display = 'none';
      document.getElementById('other-reason').removeAttribute('required');
    }
  });
}